import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz25 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel26'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel24'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Chessboard and dominos</h1>
    
    <div class="text">
        <p>There is an 8 by 8 chessboard in which two diagonally opposite corners have been cut off.You are given 31
            dominos, and a single domino can cover exactly two squares. Can you use the 31 dominos to cover the entire
            board?</p>
        <p>&nbsp;</p>
        <div class="containers">
        <p><strong>Answer:</strong><br/>
        No</p>
        <p><strong>Explanation:</strong><br/>
        At first it seems that there were 8*8 = 64 squares<br/>
        then 2 have been cut
            off so Squares remaining= 64-2 = 62<br/>
            And there are 31 dominos, so they will cover the remaining chessboard
            coz = 31*2 = 62</p>
        <p>But this is not the answer:</p><br/>
        
        <div id="AP_G4GR_5"></div>
       <br/>
       
        <p>Lets visualize it:</p>
        <p><img
                    class="alignnone size-full wp-image-20566"
                    src="https://media.geeksforgeeks.org/wp-content/uploads/chessboard-and-dominos-puzzle.png"
                    alt="Chessboard" width="600" height="600"/></p>
        <p>Each domino we set on the chessboard will always take <strong>1 Black</strong> and <strong>1 White</strong>
            square.Therefore, <strong>31 dominos</strong> will take <strong>31 white</strong> square and 31 black
            squares exactly. On this chessbord however, we must have <strong>32 black</strong> and <strong>30
                white</strong> squares. Hence it is not possible to do so.</p>
       </div>
    </div>
</article>
        </div>
    )
}

export default Puz25
